import {
  triggerToast,
  MessageTooltip,
  dateFormatterDayMonthYearAndHourMinute2Digits,
  ButtonDS,
  LoopOutlined,
  Spacer,
} from "@qivia/ui";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../redux/hooks";
import { selectLastReminderDate } from "../transactionsSlice";
import { UploadSupportingDocumentModal } from "./uploadSupportingDocumentModal";
import styled from "styled-components";

export const SendSmsButton = (props: {
  onClick: () => void;
  transactionUuid: string;
  getLastReminderDateAction: (transactionUuid: string) => void;
}) => {
  const { t } = useTranslation();
  const lastReminderDate = useAppSelector(selectLastReminderDate);

  const { getLastReminderDateAction } = props;

  const displayToasterError = useCallback(() => {
    triggerToast(t(`transactions.sendSms.isLessThan48h.errorMessage`), "error");
  }, [t]);

  useEffect(() => {
    getLastReminderDateAction(props.transactionUuid);
  }, [getLastReminderDateAction, props.transactionUuid]);

  const isRemindeLessThan48h = useMemo(() => {
    const date48hAgo = new Date();
    date48hAgo.setDate(date48hAgo.getDate() - 2);
    return !!(lastReminderDate && lastReminderDate > date48hAgo);
  }, [lastReminderDate]);

  return (
    <MessageTooltip
      title={t(`transactions.sendSms.title`)}
      text={
        (isRemindeLessThan48h &&
          lastReminderDate &&
          t(`transactions.sendSms.isLessThan48h`, {
            date: dateFormatterDayMonthYearAndHourMinute2Digits(
              new Date(lastReminderDate),
            ),
          })) ||
        ""
      }
      type={"ERROR"}
      button={
        <StyledColumn>
          <ButtonDS
            format="fill"
            buttonType="primary"
            text={t(`transactions.sendSms.button`)}
            leftIcon={<LoopOutlined />}
            onClick={() =>
              isRemindeLessThan48h ? displayToasterError() : props.onClick()
            }
            disabled={isRemindeLessThan48h}
          />

          <Spacer y={1} />

          <UploadSupportingDocumentModal
            transactionUuid={props.transactionUuid}
          />
        </StyledColumn>
      }
    />
  );
};

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
